<div class="container-fluid">
 <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
          My Diary</h5>
      </div>
<div id="mainContent" class="container">
  <div class="row pt-2">
    <div class="col-md-4">
      <label class="mb-0">Financial Year :</label>
      <div class="form-group mb-0">
        <select
          class="form-control form-control-sm"
          [id]="'financialYear'"
          [name]="'financialYear'"
          type="text"
          [(ngModel)]="selectedFY"
          matTooltip="Select Financial Year"
          matTooltipPosition="above"
          (change)="onloadWeeksForFY()"
        >
          <option [value]="null">Select</option>
          <option id="dropStyle"
            *ngFor="let financialYear of financialYearList"
            [ngValue]="financialYear"
          >
            {{ financialYear.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-4"></div>
  </div>
  <br />
  <div class="">
    <div class="row">
      <div class="col-md-12">
        <table class="table table-bordered table-striped table-sm">
          <thead class="">
            <tr>
              <th>#</th>
              <th>Week Start Date</th>
              <th>Week End Date</th>
              <th>status</th>
              <th>Diary Submitted Date</th>
              <th>Diary Approval Date</th>
            </tr>
          </thead>
          <tbody>
            <!-- {{radioSelected}} -->
            <tr
              *ngFor="let fyWeek of financialYearsWeekList; index as i"
              id="branch_{{ i + 1 }}"
            >
              <td scope="row">
                <input
                  type="radio"
                  [(ngModel)]="radioSelected"
                  name="list_name"
                  [value]="i"
                  (change)="onWeekChange(fyWeek)"
                />
              </td>
              <td>{{ fyWeek.weekStartDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ fyWeek.weekEndDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ fyWeek.status }}</td>
              <td>{{ fyWeek.submittedDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ fyWeek.approvalDate | date: "dd-MMM-yyyy" }}</td>
            </tr>
          </tbody>
        </table>
        <ngb-pagination
          [collectionSize]="collectionSize"
          [(page)]="page"
          [maxSize]="1"
          size="sm"
          [pageSize]="pageSize"
          (pageChange)="refreshCollectionList()"
        >
        </ngb-pagination>
      </div>
    </div>
  </div>
  </div>
  <br />

<div id="mainContent" class="container">
  <div class="pb-3" *ngIf="showDiariesInWeekList && financialYearsWeekList.length > 0">
    <div class="row pt-3">
      <div class="col-md-6">
        <span class="bg-theme-title">Diary Details From : </span
        ><label
          >{{
            financialYearsWeekList[radioSelected].weekStartDate
              | date: "dd-MMM-yyyy"
          }}
          To
          {{
            financialYearsWeekList[radioSelected].weekEndDate
              | date: "dd-MMM-yyyy"
          }}</label
        >
      </div>
      <div class="col-md-6">
        <button
          class="btn btn-xs btn-theme"
          style="float: right"
          matTooltip="Click to add"
          matTooltipPosition="left"
          [disabled]="
            financialYearsWeekList[radioSelected].status == 'Submitted' ||
            financialYearsWeekList[radioSelected].status == 'Approved' ||
            financialYearsWeekList[radioSelected].status == 'On Leave'
          "
          (click)="openModal('add')"
        >
        <!-- || financialYearsWeekList[radioSelected].status == 'On Leave' -->
          <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;Entry
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <table
          class="table table-bordered table-striped table-sm"
          style="display: block; overflow-x: auto; white-space: nowrap"
        >
          <thead class="">
            <tr>
              <th rowspan="2">Action</th>
              <th rowspan="2">Status</th>
              <th rowspan="2">Approver Name</th>
              <th rowspan="2">Date</th>
              <th rowspan="2">Day</th>
              <th colspan="2">Time</th>
              <th rowspan="2">No Of Hours</th>
              <th rowspan="2">No Of Extra Hours</th>
              <th colspan="2">Hours</th>
              <th rowspan="2">Client</th>
              <th rowspan="2">Assignment</th>
              <th rowspan="2">Task</th>
              <th rowspan="2">Work Performed</th>
              <th rowspan="2">Location</th>
              <th rowspan="2">Distance</th>
              <th rowspan="2">Mode</th>
              <th rowspan="2">Travelling From</th>
              <th rowspan="2">Rate</th>
              <th rowspan="2">Nature Of Expense</th>
              <th rowspan="2">Amount</th>
              <th rowspan="2">Chargable To Client</th>
            </tr>
            <tr>
              <th>In</th>
              <th>Out</th>
              <th>Dr</th>
              <th>Cr</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let diaryEntry of diariesInWeekList | orderBy: 'entryDate';
                index as i
              "
              id="diariesInWeek_{{ i + 1 }}"
            >
              <td>
                <!-- <button id="submitEntryBtn_{{i+1}}" name="submitEntryBtn_{{i+1}}" class="btn btn-link" style="padding: 2px;" (click)="submitDiary(diaryEntry)"
              matTooltip="Click to submit" matTooltipPosition="above">
              <i class="fa fa-upload" aria-hidden="true"></i>
              </button>&nbsp; -->
                <button
                  id="copyEntryBtn_{{ i + 1 }}"
                  name="copyFyBtn_{{ i + 1 }}"
                  class="btn"
                  style="padding: 2px"
                  [disabled]="
                    financialYearsWeekList[radioSelected].status ==
                      'Submitted' ||
                    financialYearsWeekList[radioSelected].status ==
                      'Approved' ||
                    diaryEntry.status == 'Approved'|| 
                    diaryEntry.status ==  'Submitted'
                  "
                  (click)="onCopyClick(diaryEntry, 'copy')"
                  matTooltip="Click to copy"
                  matTooltipPosition="above"
                >
                  <i class="fa fa-clone" aria-hidden="true"></i></button
                >&nbsp;
                <button
                  id="editEntryBtn_{{ i + 1 }}"
                  name="editFyBtn_{{ i + 1 }}"
                  class="btn"
                  style="padding: 2px"
                  [disabled]="
                    financialYearsWeekList[radioSelected].status ==
                      'Submitted' ||
                    financialYearsWeekList[radioSelected].status ==
                      'Approved' ||
                    diaryEntry.status == 'Approved' || 
                    diaryEntry.status ==  'Submitted'
                  "
                  (click)="onEditClick(diaryEntry, 'edit')"
                  matTooltip="Click to edit"
                  matTooltipPosition="above"
                >
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </button>
                &nbsp;
                <button
                  id="deleteEntryBtn_{{ i + 1 }}"
                  name="deleteEntryBtn_{{ i + 1 }}"
                  class="btn"
                  style="padding: 2px"
                  [disabled]="
                    financialYearsWeekList[radioSelected].status ==
                      'Submitted' ||
                    financialYearsWeekList[radioSelected].status ==
                      'Approved' ||
                    diaryEntry.status == 'Approved'|| 
                    diaryEntry.status ==  'Submitted'
                  "
                  (click)="onDeleteClick(diaryEntry)"
                  matTooltip="Click to delete"
                  matTooltipPosition="above"
                >
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </td>
              <td>{{ diaryEntry.status }}</td>
              <td *ngIf="diaryEntry.approver != null">
                {{ diaryEntry.approver.firstName }}
                {{ diaryEntry.approver.lastName }}
              </td>
              <td
                *ngIf="diaryEntry.approver == null && !changeApproverName"
              ></td>
              <td *ngIf="diaryEntry.approver == null && changeApproverName">
                Self Approved
              </td>
              <td>{{ diaryEntry.entryDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ diaryEntry.entryDate | date: "EEEE" }}</td>
              <td>{{ diaryEntry.inTimeHour }}.{{ diaryEntry.inTimeMin }}</td>
              <td>{{ diaryEntry.outTimeHour }}.{{ diaryEntry.outTimeMin }}</td>
              <td>
                {{ diaryEntry.noOfTimeHours }}.{{ diaryEntry.noOfTimeMin }}
              </td>
              <td>
                {{ diaryEntry.extraTimeHours }}.{{ diaryEntry.extraTimeMin }}
              </td>
              <td>
                {{ diaryEntry.debitedTimeHours }}.{{
                  diaryEntry.debitedTimeMin
                }}
              </td>
              <td>
                {{ diaryEntry.creditedTimeHours }}.{{
                  diaryEntry.creditedTimeMin
                }}
              </td>
              <td>{{ diaryEntry.client.name }}</td>
              <td>{{ diaryEntry.assignment.name }}</td>
              <td>{{ diaryEntry.task != null ? diaryEntry.task.name : "" }}</td>
              <td>{{ diaryEntry.workPerformed }}</td>
              <td>
                {{
                  diaryEntry.location != null ? diaryEntry.location.name : ""
                }}
              </td>
              <td>{{ diaryEntry.distanceFromOffice }}</td>
              <td>{{ diaryEntry.mode }}</td>
              <td>{{ diaryEntry.travellingFrom }}</td>
              <td>{{ diaryEntry.rate }}</td>
              <td>{{ diaryEntry.natureOfExpense }}</td>
              <td>{{ diaryEntry.amount }}</td>
              <td>
                <span *ngIf="diaryEntry.chargeableToClient">Yes</span>
                <span *ngIf="!diaryEntry.chargeableToClient">No</span>
              </td>
            </tr>
            <tr *ngIf="diariesInWeekList.length == 0">
              <td colspan="23" style="text-align: center;">No Entry Available</td>
              <!-- <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td colspan="4">No Entry Available</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" *ngIf="diariesInWeekList.length > 0">
      <div class="col-md-2">
        <button
          [disabled]="
            financialYearsWeekList[radioSelected].status == 'Submitted' ||
            financialYearsWeekList[radioSelected].status == 'Approved'
          "
          id="submitAllEntryBtn"
          name="submitAllEntryBtn"
          class="btn btn-xs btn-theme"
          style="float: left"
          matTooltip="Click to submit all"
          matTooltipPosition="left"
          (click)="submitAllDiaries()"
        >
          <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;Submit All
        </button>
      </div>
    </div>
  </div>
</div>

<div id="mainContent" class="container">
  <div
    class="pt-2"
    *ngIf="showLeavesInWeekList"
  >
    <div class="row">
      <div class="col-md-6">
        <span class="bg-theme-title">Leave Details From : </span
        ><label
          >{{
            financialYearsWeekList[radioSelected].weekStartDate
              | date: "dd-MMM-yyyy"
          }}
          To
          {{
            financialYearsWeekList[radioSelected].weekEndDate
              | date: "dd-MMM-yyyy"
          }}</label
        >
      </div>
      <div class="col-md-6">
        <!-- <button class="btn btn-xs btn-theme" style="float:left" matTooltip="Click to add" matTooltipPosition="left"
      (click)="openModal('add')">
          <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;Entry
      </button> -->
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <table class="table table-bordered table-striped table-sm">
          <thead class="">
            <tr>
              <th>Leave Date</th>
              <th>Leave Days</th>
              <th>Leave Type</th>
              <th>Status</th>
              <th>Approver Name</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let leaveEntry of leavesInWeekList | orderBy: 'createdDate';
                index as i
              "
              id="leavesInWeek_{{ i + 1 }}"
            >
              <td>
                {{ leaveEntry.fromDate | date: "dd-MMM-yyyy" }} To
                {{ leaveEntry.toDate | date: "dd-MMM-yyyy" }}
              </td>
              <td>{{ leaveEntry.leaveDays }}</td>
              <td>{{ leaveEntry.leaveType.name }}</td>
              <td>{{ leaveEntry.status }}</td>
              <td *ngIf="approverList.length > 0">
                {{ leaveEntry.approver.firstName }}
                {{ leaveEntry.approver.lastName }}
              </td>
              <td *ngIf="approverList.length == 0">Self Approved</td>
            </tr>
            <tr *ngIf="leavesInWeekList.length == 0">
              <td colspan="5" style="text-align: center;">No Entry Available</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</div>
<!-- Modal Template -->
<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt p-2">
    <h5 class="modal-title" id="modal-basic-title" style="text-align: center">
      Daily Diary Entry For Week
      {{
        financialYearsWeekList[radioSelected].weekStartDate
          | date: "dd-MMMM-yyyy"
      }}
      To
      {{
        financialYearsWeekList[radioSelected].weekEndDate | date: "dd-MMMM-yyyy"
      }}
    </h5>
  </div>
  <div class="modal-body">
    <form [formGroup]="modalForm">
      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Approver :</label>
            <div *ngIf="approverList.length > 0" class="col-sm-8">
              <select
                ngbAutofocus
                class="form-control form-control-xs"
                id="approver"
                name="approver"
                formControlName="approver"
                matTooltip="{{ formErrors.approver }}"
                matTooltipPosition="above"
              >
                <option [ngValue]="null">Select Approver Name</option>
                <option
                  *ngFor="let approver of approverList"
                  [ngValue]="approver"
                >
                  {{ approver.firstName }} {{ approver.lastName }}
                </option>
              </select>
            </div>
            <div *ngIf="approverList.length == 0" class="col-sm-8">
              <input
                type="text"
                value="Self Approved"
                class="form-control form-control-xs"
                [disabled]="true"
              />
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Date :</label>
            <div class="col-sm-8">
              <div class="input-group">
                <input
                  id="entryDate"
                  name="entryDate"
                  class="form-control form-control-xs"
                  placeholder="dd/mm/yyyy"
                  ngbDatepicker
                  #entryDate="ngbDatepicker"
                  formControlName="entryDate"
                  (dateSelect)="onEntryDateChange()"
                  [minDate]="entryDateMin"
                  [maxDate]="entryDateMax"
                  matTooltip="{{ formErrors.entryDate }}"
                  matTooltipPosition="above"
                  [class.is-invalid]="formErrors.entryDate && formSubmitted"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-outline-theme fa fa-calendar btn-xs"
                    (click)="entryDate.toggle()"
                    type="button"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="isHoliday">
        <div class="col-sm-6"></div>
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-4"></div>
            <div class="col-sm-8">
              <span style="color: red"> Holiday ..!! </span>
            </div>
          </div>
        </div>
      </div>

      <hr />
      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Client :</label>
            <div class="col-sm-8">
              <select
                class="form-control form-control-xs"
                id="client"
                name="client"
                formControlName="client"
                (change)="loadClientLocationList(modalForm.get('client').value)"
                matTooltip="{{ formErrors.client }}"
                matTooltipPosition="above"
                [class.is-invalid]="formErrors.client && formSubmitted"
              >
                <option [ngValue]="null">Select Client Name</option>
                <option
                  *ngFor="let client of diaryClientList"
                  [ngValue]="client"
                >
                  {{ client.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Location :</label>
            <div class="col-sm-8">
              <select
                class="form-control form-control-xs"
                id="location"
                name="location"
                formControlName="location"
                matTooltip="{{ formErrors.location }}"
                matTooltipPosition="above"
                (change)="onLocationChange(modalForm.get('location').value)"
                [class.is-invalid]="formErrors.location && formSubmitted"
              >
                <option [ngValue]="null">Select Location Name</option>
                <option
                  *ngFor="let location of clientLocationList"
                  [ngValue]="location"
                >
                  {{ location.city.name }} - {{ location.address }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label for="assignmentId" class="col-sm-4 col-form-label"
              >Assignment :</label
            >
            <div class="col-sm-8">
              <select
                class="form-control form-control-xs"
                id="assignment"
                name="assignment"
                formControlName="assignment"
                (change)="loadAssignmentTask(modalForm.get('assignment').value)"
                matTooltip="{{ formErrors.assignment }}"
                matTooltipPosition="above"
                [class.is-invalid]="formErrors.assignment && formSubmitted"
              >
                <option [ngValue]="null">Select Assignment Name</option>
                <option
                  *ngFor="let assignment of assignmentList"
                  [ngValue]="assignment"
                >
                  {{ assignment.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Task :</label>
            <div class="col-sm-8">
              <select
                class="form-control form-control-xs"
                id="task"
                name="task"
                formControlName="task"
                matTooltip="{{ formErrors.task }}"
                matTooltipPosition="above"
                [class.is-invalid]="formErrors.task && formSubmitted"
              >
              <!-- (change)="
                  loadBudgetedFinancialYearList(modalForm.get('task').value)
                " -->
                <option [ngValue]="null">Select Task</option>
                <option *ngFor="let task of taskList" [ngValue]="task">
                  {{ task.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label for="assignmentForFY" class="col-sm-4 col-form-label"
              >For FY :</label
            >
            <div class="col-sm-8">
              <select
                class="form-control form-control-xs"
                id="assignmentForFY"
                name="assignmentForFY"
                formControlName="assignmentForFY"
                (change)="
                  checkBudgetAfterFyClick(
                    modalForm.get('assignmentForFY').value
                  )
                "
                matTooltip="{{ formErrors.assignmentForFY }}"
                matTooltipPosition="above"
                [class.is-invalid]="formErrors.assignmentForFY && formSubmitted"
              >
                <option [ngValue]="null">Select For FY</option>
                <option [ngValue]="17" >2026-2027 </option>
                <option [ngValue]="16" >2025-2026 </option>
                <option [ngValue]="14" >2024-2025 </option>
                <!-- <option [ngValue]="12" >2022-2023 </option> -->
                <!-- <option [ngValue]="10" >2021-2022 </option> -->
                <!-- <option [ngValue]="9" >2020-2021 </option> -->
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-6"></div>
      </div>
      <hr />
      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label for="inTime" class="col-sm-4 col-form-label"
              >In Time :</label
            >
            <div class="col-sm-8">
              <ngb-timepicker
                id="inTime"
                name="inTime"
                formControlName="inTime"
                (ngModelChange)="onChangeOutTime()"
              ></ngb-timepicker>
              <span
                class="text-danger"
                *ngIf="formErrors.inTime && formSubmitted"
                >enter inTime</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <label for="outTime" class="col-sm-4 col-form-label"
              >Out Time :</label
            >
            <div class="col-sm-8">
              <ngb-timepicker
                id="outTime"
                name="outTime"
                formControlName="outTime"
                outTime
                (ngModelChange)="onChangeOutTime()"
              ></ngb-timepicker>
              <span
                class="text-danger"
                *ngIf="formErrors.outTime && formSubmitted"
                >enter outTime</span
              >
              <span class="text-danger" *ngIf="!isTimeValid.isValid">{{
                isTimeValid.error
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label for="NoOfHours" class="col-sm-4 col-form-label"
              >NoOfHours :</label
            >
            <div class="col-sm-8 col-form-label">
              {{ modalForm.value.noOfTimeHours }} Hours :
              {{ modalForm.value.noOfTimeMin }} Minutes
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <label for="outTime" class="col-sm-4 col-form-label"
              >Extra Hours :</label
            >
            <div class="col-sm-8">
              {{ modalForm.value.extraTimeHours }} Hours :
              {{ modalForm.value.extraTimeMin }} Minutes
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label for="inTime" class="col-sm-4 col-form-label"
              >Dr Hours :</label
            >
            <div class="col-sm-8 col-form-label">
              {{ modalForm.value.debitedTimeHours }} Hours :
              {{ modalForm.value.debitedTimeMin }} Minutes
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <label for="outTime" class="col-sm-4 col-form-label"
              >Cr Hours :</label
            >
            <div class="col-sm-8 col-form-label">
              {{ modalForm.value.creditedTimeHours }} Hours :
              {{ modalForm.value.creditedTimeMin }} Minutes
            </div>
          </div>
        </div>
      </div>
      <hr />

      <div class="row" *ngIf="showTravelAgainButton">
        <div class="col-md-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              name="travelAgainSatus"
              id="travelAgainSatus"
              [value]="true"
              formControlName="travelAgainSatus"
              (change)="onChangeTravelAgain('copy')"
            />
            <label class="col-form-label" style="font-weight: bold"
              >Do you travel again</label
            >
          </div>
        </div>
      </div>

      <div
        class="row"
        *ngIf="
          modalForm.get('travelAgainSatus').value || !showTravelAgainButton
        "
      >
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-4" style="padding-right: 0px">
              <label for="travellingFrom" class="col-form-label"
                >Travelling From :</label
              >
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="travellingFrom"
                  id="travellingFrom1"
                  [value]="'Office to Client'"
                  formControlName="travellingFrom"
                  (change)="changeTravellingFrom()"
                />
                <label class="col-form-label" style="font-weight: 400"
                  >Office to Client</label
                >
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="travellingFrom"
                  id="travellingFrom2"
                  [value]="'Home to Client / Other'"
                  formControlName="travellingFrom"
                  (change)="changeTravellingFrom()"
                />
                <label class="col-form-label" style="font-weight: 400"
                  >Home to Client / Other</label
                >
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="travellingFrom"
                  id="travellingFrom3"
                  [value]="'NA'"
                  formControlName="travellingFrom"
                  (change)="changeTravellingFrom()"
                />
                <label class="col-form-label" style="font-weight: 400"
                  >NA</label
                >
              </div>
            </div>
            <div class="col-sm-4" style="padding: 0px">
              <label for="mode" class="col-form-label">Mode :</label>
              <div class="form-check" *ngIf="conveyanceRate && conveyanceRate.allowTwoWheeler">
                <input
                  class="form-check-input"
                  type="radio"
                  name="mode"
                  id="mode1"
                  [value]="'Two Wheeler'"
                  formControlName="mode"
                  (change)="changeTravellingMode()"
                />
                <label class="col-form-label" style="font-weight: 400"
                  >Two Wheeler</label
                >
              </div>

              <div class="form-check" *ngIf="conveyanceRate && conveyanceRate.allowFourWheeler">
                <input
                  class="form-check-input"
                  type="radio"
                  name="mode"
                  id="mode2"
                  [value]="'Four Wheeler'"
                  formControlName="mode"
                  (change)="changeTravellingMode()"
                />
                <label class="col-form-label" style="font-weight: 400"
                  >Four Wheeler</label
                >
              </div>

              <!-- <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="mode"
                  id="mode3"
                  [value]="'Bus/Auto/Other'"
                  formControlName="mode"
                  (change)="changeTravellingMode()"
                />
                <label class="col-form-label" style="font-weight: 400"
                  >Bus/Auto/Other</label
                >
              </div> -->
            </div>
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-8" style="padding: 0px">
                  <label class="col-form-label">Distance From Office</label>
                </div>
                <div class="col-sm-4">
                  <label
                    class="col-form-label"
                    *ngIf="
                      modalForm.getRawValue().location &&
                      !(
                        modalForm.getRawValue().travellingFrom ==
                        'Home to Client / Other'
                      )
                    "
                    >: {{ modalForm.value.distanceFromOffice }}</label
                  >
                  <span
                    *ngIf="
                      modalForm.getRawValue().location &&
                      modalForm.getRawValue().travellingFrom ==
                        'Home to Client / Other'
                    "
                  >
                    <input
                      style=""
                      class="form-control form-control-sm"
                      type="number"
                      name="distanceFromOffice"
                      id="distanceFromOffice"
                      formControlName="distanceFromOffice"
                      (change)="changeDistanceFromOffice()"
                      matTooltip="{{ formErrors.distanceFromOffice }}"
                      matTooltipPosition="above"
                      [class.is-invalid]="
                        formErrors.distanceFromOffice &&
                        formSubmitted &&
                        !isDist
                      "
                    />
                  </span>
                </div>
                <span style="color: red" *ngIf="isDist"
                  >distance should be less than or equal to {{ distFromOffice }}
                </span>
              </div>

              <div class="row">
                <div class="col-sm-8" style="padding: 0px">
                  <label class="col-form-label">Chargable To Client</label>
                </div>
                <div class="col-sm-4">
                  <label
                    class="col-form-label"
                    *ngIf="modalForm.value.chargeableToClient"
                    >: Yes</label
                  >
                  <label
                    class="col-form-label"
                    *ngIf="!modalForm.value.chargeableToClient"
                    >: No</label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-sm-8" style="padding: 0px">
                  <label class="col-form-label">Rate</label>
                </div>
                <div class="col-sm-4">
                  <label class="col-form-label"
                    >: {{ modalForm.value.rate }}</label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-sm-8" style="padding: 0px">
                  <label class="col-form-label">Amount</label>
                </div>
                <div class="col-sm-4">
                  <label
                    class="col-form-label"
                    *ngIf="!(modalForm.value.mode == 'Bus/Auto/Other')"
                    >: {{ modalForm.value.amount }}</label
                  >
                  <span *ngIf="modalForm.value.mode == 'Bus/Auto/Other'">
                    :
                    <input
                      style="width: 50%"
                      class="form-check-input"
                      type="number"
                      name="amount"
                      id="amount"
                      formControlName="amount"
                      min="0"
                      onKeyPress="if(this.value.length==4) return false;"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="modalForm.value.mode == 'Bus/Auto/Other'">
            <div class="col-sm-4" style="padding: 0px"></div>
            <div class="col-sm-4" style="padding: 0px">
              <label class="col-form-label">Nature Of Expense</label>
            </div>
            <div class="col-sm-4">
              <span>
                :
                <input
                  style="width: 50%"
                  class="form-check-input"
                  type="text"
                  name="natureOfExpense"
                  id="natureOfExpense"
                  formControlName="natureOfExpense"
                  [class.is-invalid]="
                    formErrors.natureOfExpense && formSubmitted
                  "
                  min="0"
                />
              </span>
            </div>
          </div>
        </div>
      </div>

      <hr />
      <div class="row">
        <div class="col-sm-12">
          <div class="row">
            <label class="col-sm-3 col-form-label">Work Performed :</label>
            <div class="col-sm-9">
              <textarea
                style="overflow: auto; resize: none"
                rows="2"
                class="form-control form-control-sm"
                id="workPerformed"
                name="workPerformed"
                formControlName="workPerformed"
                matTooltip="{{ formErrors.workPerformed }}"
                matTooltipPosition="above"
                [class.is-invalid]="formErrors.workPerformed && formSubmitted"
              ></textarea>
              <!-- <span class="text-danger" *ngIf="workPerformed.touched && !workPerformed.valid">enter work performed</span> -->
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
    
      <div class="col-sm-3">
        <button
          type="button"
          *ngIf="modalStatus == 'add' || modalStatus == 'copy'"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onSaveClick()"
        >
          Save
        </button>
        <button
          type="button"
          *ngIf="modalStatus == 'edit'"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onUpdateClick()"
        >
          Update
        </button>
      </div>
      <div class="col-sm-3">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="closeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>
